import React, { useState } from "react";

import { useTranslation } from "utils";

import { Button, Card, Flex, Tag, TagColour, Typography } from "components";

interface AdditionItem {
  id: string;
  name: string;
  icon: React.ReactNode;
  isComplete: boolean;
}

interface FormCardButtonAdditionProps {
  items: AdditionItem[];
  onItemClick?: (itemId: string) => void;
  completeText?: string;
  incompleteText?: string;
  completeColor?: TagColour;
  incompleteColor?: TagColour;
}

const MAX_ITEMS_SHOWN = 6;

export const FormCardButtonAddition = ({
  items,
  onItemClick,
  completeText = "",
  incompleteText = "",
  completeColor = "green",
  incompleteColor = "grey",
}: FormCardButtonAdditionProps) => {
  const { t } = useTranslation(["footprinting"]);
  const [showAll, setShowAll] = useState(false);

  if (items.length === 0) {
    return null;
  }

  const hasMoreItems = items.length > MAX_ITEMS_SHOWN;
  const displayedItems = showAll ? items : items.slice(0, MAX_ITEMS_SHOWN);

  return (
    <Flex vertical gap={8} className="padding-100">
      <Flex className="addition-cards-container" gap={8}>
        {displayedItems.map((item) => (
          <Card key={item.id} className="addition-card padding-100" onClick={() => onItemClick?.(item.id)}>
            <Flex gap={8} align="center" justify="space-between">
              <Flex className="icon-name-container" align="center" gap={4}>
                <div className="addition-card-icon">{item.icon}</div>
                <Typography variant="paragraph-m" className="item-name">
                  {item.name}
                </Typography>
              </Flex>
              {(completeText || incompleteText) && (
                <Tag text={item.isComplete ? completeText : incompleteText} colour={item.isComplete ? completeColor : incompleteColor} />
              )}
            </Flex>
          </Card>
        ))}
      </Flex>

      {hasMoreItems && (
        <Flex justify="center" className="padding-top-50">
          <Button type="text" size="small" onClick={() => setShowAll(!showAll)}>
            {showAll ? t("showMoreToggle.showLess") : `${t("showMoreToggle.showMore")} (${items.length - MAX_ITEMS_SHOWN})`}
          </Button>
        </Flex>
      )}
    </Flex>
  );
};
